<script setup lang="ts">
import { ref } from 'vue';
import SideMenuBottom from '@/presentation/components/mainmenu/SideMenuBottom.vue';
import SideMenuMain from '@/presentation/components/mainmenu/SideMenuMain.vue';
import SideMenuToggleButton from '@/presentation/components/mainmenu/SideMenuToggleButton.vue';

const collapsed = ref(false);
</script>

<template>
  <div class="flex h-[calc(100vh-70px)] overflow-hidden">
    <aside
      :class="[
      'bg-slate-700 text-gray-200 flex flex-col transition-all duration-300 ease-in-out  custom-scrollbar',
      collapsed ? 'w-14' : 'w-56'
    ]">
      <div class="flex flex-row justify-end">
        <span
          v-if="!collapsed"
          class="flex-1 ml-6 font-bold text-lg leading-[3] transition-all ease-in-out duration-500"
        >
          Menu
        </span>

        <SideMenuToggleButton class="justify-items-end" @toggled="collapsed = $event"/>
      </div>

      <SideMenuMain :collapsed="collapsed"/>
      <SideMenuBottom :collapsed="collapsed"/>
    </aside>

    <main class="flex-1 overflow-y-auto transition-all duration-300 ease-in-out">
      <slot/>
    </main>
  </div>
</template>

<style scoped lang="scss">
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 #334155;
}

.custom-scrollbar::-webkit-scrollbar {
  @apply w-1.5;
}

.custom-scrollbar::-webkit-scrollbar-track {
  @apply bg-slate-700;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  @apply bg-slate-500 rounded-s;
}
</style>

